import type { FaireProductEntity } from "../../entity_types/product";

export const p_tjgspf2m9v: FaireProductEntity = {
  token: "p_tjgspf2m9v",
  type: "product",
  name: "Family Guy Brian Griffin Brick Building Figure",
  brandToken: "b_u6s27vxprc",
  brandName: "Brickcraft",
  imageUrl:
    "https://cdn.faire.com/fastly/df69d6d8ae636066b8b3c872701fd782dd2240cd93a3f7d50a37c9cd78652ed2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2086700c31a9095beedb5cb2864b55a471a4951d32903cae44fb16db83cd7a8b.jpeg",
    "https://cdn.faire.com/fastly/027c0237e4b2b8664a957312fca6f085f7d236ee62377d8b71beabd625e5043b.jpeg",
    "https://cdn.faire.com/fastly/71d0247417cee0e14277d7c9d36ddabaa1be7e3a623464864e4ea89898681cc4.jpeg",
    "https://cdn.faire.com/fastly/7391ad9e7237170cc56376a5fd1a6a2daf04c54d88e0eae8c2b32d2b31bb0bc2.jpeg",
    "https://cdn.faire.com/fastly/4e423bc7c3944deb8f8a1a03db4db17e015da674e708f0d5e591b069f6797a40.jpeg",
    "https://cdn.faire.com/fastly/48fdb11f95aeaed4b791769902a984a6760c72b701057ee3a08f25f379076f06.jpeg",
    "https://cdn.faire.com/fastly/2a850d6b2a95dab42589463fff9d0f1074aa847784130e4a375e410e7e5570ab.jpeg",
    "https://cdn.faire.com/fastly/2a0c01dbc98aa4a1c34a58ddd986fad6ea24a7df7b47277a2aafbb0cb4bd1b36.jpeg",
  ],
  priceDollars: 12.4,
  description:
    "Bring Quahog’s most sophisticated dog to life with this brick-built Brian Griffin figure. Featuring his signature expression, red collar, and printed details, the set includes both a martini glass and a “Who’s a Good Boy?” mug so you can switch from AM to PM. Finished with a printed Family Guy logo on the display stand, this build is full of personality and ready for any fan collection.",
  tags: [],
  msrpDollars: 24.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:56.814Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
